import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-secondary-toolbar-button',
  templateUrl: './secondary-toolbar-button.component.html',
  styleUrls: ['./secondary-toolbar-button.component.scss']
})
export class SecondaryToolbarButtonComponent {
  @Input() titleStringKey: string = '';

  @Input() iconClass: string = '';
}
